export default __webpack_public_path__ + "static/media/signin-opinion.6e3d6556.png";